import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BrandInput, BrandSearchInput, FilterInput } from '../../inputs';
import { brandBannerResponse, BrandInfoNewResponse, BrandRecordsResponse, BrandRecordsResponseUser, BrandResponseUser, BrandsResponse, OneBrandResponse, ProductsListResponse, SingleBrandResponse, SubmitResponse } from '../../models';
import { LanguageService } from '../common/language.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class BrandService extends HttpService<FilterInput | BrandInput | BrandSearchInput, BrandsResponse | OneBrandResponse | BrandRecordsResponse | SingleBrandResponse | ProductsListResponse | BrandInfoNewResponse | BrandRecordsResponseUser | BrandResponseUser | brandBannerResponse | SubmitResponse> {
  languageService = inject(LanguageService);

  constructor(httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'brand');
  }

  getAllBrands(page = 1,limit?:number): Observable<BrandsResponse> {
    return this.getAllPaged('admin', page, '', limit) as Observable<BrandsResponse>;
  }

  findAllByName(text: string, page = 1): Observable<BrandsResponse> {
    const filter: FilterInput = {
      page: page,
      limit: 10,
      filters: {
        and: [['brand_translations.name', 'ILIKE', `%${text}%`]]
      }
    };
    return this.filterAllActionPagedAdmin(filter,'admin') as Observable<BrandsResponse>;
  }

  getFilteredBrands(searchTerm: string): Observable<BrandsResponse> {
    return this.getAll(`admin/filter?page=1&lang_code=${this.languageService.currentLanguage}&key=name&value=${searchTerm}`) as Observable<BrandsResponse>;
  }

  getBrandById(id: number): Observable<OneBrandResponse> {
    return this.getById(id) as Observable<OneBrandResponse>;
  }
  getBrandAdminById(id: number): Observable<BrandInfoNewResponse> {
    return this.getById(id,"admin") as Observable<BrandInfoNewResponse>;
  }

  createBrand(brand: BrandInput): Observable<SubmitResponse> {
    return this.create(brand, '');
  }

  updateBrand(id: any, brand: BrandInput): Observable<SubmitResponse> {
    return this.update(brand, id);
  }

  deleteBrand(brandId: number): Observable<SubmitResponse> {
    return this.delete(brandId);
  }

  // Refactored

  getHomeBrands(page: number = 1, limit: number = 1000): Observable<BrandsResponse> {
    const currentLang = this.languageService.currentLanguage;
    return this.getBy('', { page: page, limit: limit, lang_code: currentLang }) as Observable<BrandsResponse>;
  }
  getBrandBanners(page: number = 1, limit: number = 1000): Observable<brandBannerResponse> {
    const currentLang = this.languageService.currentLanguage;
    return this.getBy('banners/customer/list', { page: page, limit: limit }) as Observable<brandBannerResponse>;
  }
  getPremiumBrands(page: number = 1, limit: number = 1000): Observable<BrandRecordsResponse> {
    const currentLang = this.languageService.currentLanguage;
    return this.getBy('premium', { page: page, limit: limit, lang_code: currentLang }) as Observable<BrandRecordsResponse>;
  }
  getPremiumBrandsBanner(page: number = 1, limit: number = 1000): Observable<BrandRecordsResponse> {
    const currentLang = this.languageService.currentLanguage;
    return this.getBy('premium1', { page: page, limit: limit, lang_code: currentLang }) as Observable<BrandRecordsResponse>;
  }


  getBySlugs(slugs: string[]): Observable<BrandsResponse> {
    const input: FilterInput = {
      page: 1,
      limit: slugs.length,
      filters: {
        and: [['slug', 'in', slugs]]
      }
    };
    return this.filterAllPaged(input) as Observable<BrandsResponse>;
  }

  getByIds(ids: number[]): Observable<BrandsResponse> {
    const input: FilterInput = {
      page: 1,
      limit: ids.length,
      filters: {
        and: [['id', 'in', ids]]
      }
    };
    return this.filterAllPaged(input) as Observable<BrandsResponse>;
  }
  getBrandBySlug(id: string): Observable<BrandResponseUser> {
    return this.getById(id) as Observable<BrandResponseUser>;
  }
  getVideoVariants(page: number, brandSlug = ''): Observable<ProductsListResponse> {
    return this.getAllPaged(`${brandSlug}/videos`, page) as Observable<ProductsListResponse>;
  }
 searchBrands(payload:BrandSearchInput): Observable<BrandRecordsResponseUser> {
    
    return this.filterAllPaged(payload) as Observable<BrandRecordsResponseUser>;
  }

}
